import { render, staticRenderFns } from "./blsx.vue?vue&type=template&id=3fbb99ca"
import script from "./blsx.vue?vue&type=script&lang=js"
export * from "./blsx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports